import { ReactNode } from 'react';
import styled from 'styled-components';

import Button from 'components/shared/Button';
import { colors } from 'styles/theme/colors';
import { Body, H3 } from 'styles/typography';

// The non-result states: payer not enrolled, no results found, and the generic error fallback,
// plus a neutral pending/running message. Icon + title + copy, with an optional Try Again action.

interface Props {
  icon: ReactNode;
  title: string;
  body: ReactNode;
  onTryAgain?: () => void;
  isRetrying?: boolean;
}

export default function EligibilityEmptyState({ icon, title, body, onTryAgain, isRetrying }: Props) {
  return (
    <Panel data-testid='eligibility-empty-state'>
      <Icon aria-hidden>{icon}</Icon>
      <Title>{title}</Title>
      <Copy>{body}</Copy>
      {onTryAgain && (
        <Button onClick={onTryAgain} loading={isRetrying} disabled={isRetrying} data-testid='eligibility-try-again'>
          Try Again
        </Button>
      )}
    </Panel>
  );
}

const Panel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
  padding: 64px 24px;
  border-radius: 8px;
  background: ${colors.black3};
`;

const Icon = styled.div`
  color: ${colors.red100};
  display: inline-flex;
`;

const Title = styled(H3)`
  color: ${colors.black100};
`;

const Copy = styled(Body)`
  color: ${colors.black75};
  max-width: 520px;
`;
